<script>
// import RexModal from '@/rex-components/rex-modal.vue';
import RexModalV3 from '@/rex-components/RexModalV3.vue';
// import RexButton from '@/rex-components/rex-button.vue';
import RexModalLabel from '@/rex-components/rex-modal-label.vue';
import RexModalInput from '@/rex-components/rex-modal-input.vue';
import RexModalTextarea from '@/rex-components/rex-modal-textarea.vue';
import RexInfoLabel from '@/rex-components/rex-info-label.vue';
import { LOGService } from '@/services/api/log.service';
import { mapState, mapGetters, mapMutations } from 'vuex';
import { grokSystemGeneratedLabel } from '@/components/Log/log.types';
import { LOG_GROK_PATTERN_LENGTH, DESC } from '@/components/Log/log.constants';
import RexInfiniteScrollDropdown from '@/rex-components/RexInfiniteScrollDropdown.vue';
import { PAGE_SIZE_SCROLL } from '@/utils/constants';
import { parseServiceObjFromApplication } from '@/utils/helper-function';

export default {
  components: {
    RexModalV3,
    // RexButton,
    RexModalLabel,
    RexModalInput,
    RexModalTextarea,
    RexInfoLabel,
    RexInfiniteScrollDropdown,
  },
  computed: {
    ...mapState('globalState/user', ['teamID']),
    ...mapState('logState/logCommonState', ['sourceList', 'sourceCurrentPage']),
    ...mapGetters('globalState/settings', ['getDurationTime']),
    getSubmitBtnText() {
      return this.isEdit ? this.$t('log.update') : this.$t('log.create');
    },
    getFormTitle() {
      return this.isEdit
        ? this.$t('log.editGrokPattern')
        : this.$t('log.createGrokPattern');
    },
  },
  props: {
    initValues: {
      type: Object,
      default: () => ({}),
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      patternName: this.initValues.patternName || '',
      source: this.initValues.source || '',
      tag: this.initValues.tag || '',
      grokPattern: this.initValues.grokPattern || '',
      sourcesListGrok: [],
      tagsList: [],
      isLoading: false,
      patternNameErrMsg: '',
      grokPatternErrMsg: '',
      isGroup: this.initValues?.isGroup ?? false,
      currentSourcePage: 1,
      selectedService: this.initValues?.label ?? '',
      stopInfiniteSourceScroll: false,
      searchService: '',
      currentTagPage: 1,
      stopInfiniteTagScroll: false,
      searchTag: '',
      isTagLoading: false,
    };
  },
  methods: {
    ...mapMutations('globalState/app', ['setIsFormOpened']),
    async getSources() {
      try {
        // TODO: loading component should be displayed
        this.isLoading = true;
        const { data } = await LOGService.getSourcesList({
          team_id: this.teamID,
          duration: this.getDurationTime,
          limit: PAGE_SIZE_SCROLL,
          offset: this.currentSourcePage,
          order: DESC,
          searchKeyword: this.searchService || '',
        });

        const sources = data
          ? data.map((obj) => ({
              label: obj.service_name,
              key: obj.service_id,
              isGroup: obj?.is_group ?? false,
              color: obj.is_group ? 'rgb(59, 191, 85)' : 'rgb(245, 150, 0)',
            }))
          : [];
        this.selectedService = !this.selectedService
          ? this.sourceList.find((item) => this.source === item.value)?.name ??
            this.parseSourceObj(this.source)?.name
          : this.selectedService;
        this.stopInfiniteSourceScroll = sources.length < PAGE_SIZE_SCROLL;
        this.currentSourcePage === 1
          ? (this.sourcesListGrok = sources)
          : this.sourcesListGrok.push(...sources);
        this.isGroup = !this.isEdit
          ? Array.isArray(this.sourcesListGrok) &&
            this.sourcesListGrok.find((obj) => obj.key === this.source)?.isGroup
          : this.isGroup;

        if (this.source && !this.isGroup) this.getTags();
        this.isLoading = false;
      } catch (error) {
        console.log('error', error);
        this.sourcesListGrok = [];
        this.isLoading = false;
      }
    },
    scrollServices() {
      this.currentSourcePage++;
      this.getSources();
    },
    onSearchService(val) {
      this.currentSourcePage = 1;
      this.searchService = val;
      this.sourcesListGrok = [];
      this.getSources();
    },
    onOpenSelectField(open) {
      if (open && this.searchService) {
        this.currentSourcePage = 1;
        this.searchService = '';
        this.getSources();
      }
    },
    async getTags() {
      try {
        this.isTagLoading = true;
        const { data } = await LOGService.getTagsList({
          service_id: this.source,
          duration: this.getDurationTime,
          limit: PAGE_SIZE_SCROLL,
          offset: this.currentTagPage,
          searchKeyword: this.searchTag,
        });
        let resp = data
          ? data.data?.tags.map((tag) => ({ key: tag, label: tag }))
          : [];
        this.currentTagPage === 1
          ? (this.tagsList = resp)
          : this.tagsList.push(...resp);
        this.stopInfiniteTagScroll = this.tagsList.length < PAGE_SIZE_SCROLL;
        if (!this.tag) {
          this.tag = this.tagsList[0]?.label;
        }
        this.isTagLoading = false;
      } catch (error) {
        console.log('error', error);
        this.tagsList = [];
        this.isTagLoading = false;
      }
    },
    scrollTags() {
      this.currentTagPage++;
      this.getTags();
    },
    onSearchTags(val) {
      this.currentTagPage = 1;
      this.searchTag = val;
      this.getTags();
    },
    onOpenSelectFieldTag(open) {
      if (open && this.searchTag) {
        this.currentTagPage = 1;
        this.searchTag = '';
        this.getTags();
      }
    },
    validateGrokForm() {
      const regex = new RegExp('^[-_a-zA-Z0-9 ]+$');
      this.patternNameErrMsg =
        (!regex.test(this.patternName) ||
          !this.patternName.trim() ||
          this.patternName.length > 50 ||
          (!this.isEdit && this.patternName === grokSystemGeneratedLabel)) &&
        this.$t('log.enterValidGrokPatternName');

      this.grokPatternErrMsg =
        (!this.grokPattern ||
          !this.grokPattern.trim() ||
          this.grokPattern.length > LOG_GROK_PATTERN_LENGTH) &&
        this.$t('log.enterValidGrokPattern');
      return !this.patternNameErrMsg && !this.grokPatternErrMsg;
    },
    onSubmitForm() {
      if (this.validateGrokForm()) {
        this.$emit('onSubmit', {
          source: this.source,
          tag: this.tag,
          patternName: this.patternName,
          grokPattern: this.grokPattern,
          isGroup: this.isGroup,
        });
      }
    },
    onSourceChange(value, option) {
      this.source = option?.key.split('-')[0];
      this.selectedService = value;
      this.tag = '';
      this.isGroup = option ? option?.metaProperty?.isGroup : this.isGroup;
      !this.isGroup && this.getTags();
      if (this.searchService) {
        this.searchService = '';
        this.currentSourcePage = 1;
        this.getSources();
      }
    },
    onTagChange(value, option) {
      this.tag = option?.key.split('-').slice(0, -1).join('-');
      if (this.searchTag) {
        this.searchTag = '';
        this.currentTagPage = 1;
        this.getTags();
      }
    },
    parseSourceObj(source) {
      const service = {
        key: source,
      };
      return parseServiceObjFromApplication(service);
    },
  },
  created() {
    this.currentSourcePage = this.sourceCurrentPage + 1;
    this.sourcesListGrok = this.sourceList.map((obj) => ({
      label: obj?.name,
      key: obj?.value,
      isGroup: obj?.isGroup ?? false,
      color: obj?.isGroup ? 'rgb(59, 191, 85)' : 'rgb(245, 150, 0)',
    }));
    this.getSources();
  },
  unmounted() {
    this.setIsFormOpened(false);
  },
};
</script>

<template>
  <div>
    <RexModalV3
      :show="true"
      @onClose="$emit('onClose')"
      @onSubmit="onSubmitForm"
      class="log-create-grok"
      :submitText="getSubmitBtnText"
      :title="getFormTitle"
    >
      <template #body>
        <div>
          <div>
            <RexModalLabel
              :primaryLabel="$t('log.grokPatternName')"
              secondaryLabel="*"
              :infoIconReq="true"
              :infoIconTooltipText="$t('log.patternNameInfo')"
              labelForId="log-grok-pattern-form-pattern-name"
            />
          </div>
          <div class="grok-input-fields">
            <RexModalInput
              type="text"
              :placeholder="$t('log.enterName')"
              v-model="patternName"
              id="log-grok-pattern-form-pattern-name"
              :maxLength="50"
            />
            <RexInfoLabel
              :isError="true"
              v-if="!!patternNameErrMsg"
              :info="patternNameErrMsg"
            />
          </div>
          <div class="grok-service-label">
            <RexModalLabel
              :primaryLabel="$t('log.service')"
              secondaryLabel="*"
              labelForId="log-grok-pattern-form-source"
            />
            <div class="grok-service-info">
              <div>{{ $t('log.note') }}</div>
              <div :class="['grok-service-info-icon', 'grouped']"></div>
              <div>{{ $t('log.grouped') }}</div>
              <div :class="['grok-service-info-icon', 'non-grouped']"></div>
              <div>{{ $t('log.nonGrouped') }}</div>
            </div>
          </div>
          <div>
            <RexInfiniteScrollDropdown
              :value="selectedService"
              :options="sourcesListGrok"
              id="select-application-service"
              :loading="isLoading"
              :stopInfiniteScroll="stopInfiniteSourceScroll"
              :customStyle="{ width: '31.175rem', marginBottom: '1.5rem' }"
              @onDropdownVisibleChange="onOpenSelectField"
              @onPopupScroll="scrollServices"
              @onChange="onSourceChange"
              @onSearch="onSearchService"
              :searchKeyword="searchService"
              :disabled="isEdit"
              :showSearch="true"
            />
          </div>

          <div v-if="!isGroup">
            <div>
              <RexModalLabel
                :primaryLabel="$t('log.logName')"
                secondaryLabel="*"
                labelForId="log-grok-pattern-form-tag"
              />
            </div>
            <div>
              <RexInfiniteScrollDropdown
                :value="tag"
                :options="tagsList"
                id="select-application-tag"
                :loading="isTagLoading"
                :stopInfiniteScroll="stopInfiniteTagScroll"
                :customStyle="{ width: '31.175rem', marginBottom: '1.5rem' }"
                @onDropdownVisibleChange="onOpenSelectFieldTag"
                @onPopupScroll="scrollTags"
                @onChange="onTagChange"
                @onSearch="onSearchTags"
                :searchKeyword="searchTag"
                :disabled="isEdit"
                :showSearch="true"
              />
            </div>
          </div>

          <div>
            <RexModalLabel
              :primaryLabel="$t('log.grokPattern')"
              secondaryLabel="*"
              labelForId="log-grok-pattern-form-grok-pattern"
            />
          </div>
          <div>
            <RexModalTextarea
              :placeholder="$t('log.enterGrokPattern')"
              class="grok-input-text-field"
              v-model="grokPattern"
              id="log-grok-pattern-form-grok-pattern"
            />
            <RexInfoLabel
              :isError="true"
              v-if="!!grokPatternErrMsg"
              :info="grokPatternErrMsg"
            />
          </div>
        </div>
      </template>

      <!-- <template v-slot:footer>
        <div class="footer-container">
          <div></div>
          <div>
            <RexButton
              class="cancel-btn"
              variant="secondary"
              id="log-grok-pattern-form-cancel"
              :styling="{ width: 'auto' }"
              @onClick="$emit('onClose')"
            >
              {{ $t('log.cancel') }}
            </RexButton>
            <RexButton
              class="submit-btn"
              variant="primary"
              :styling="{ width: '9rem' }"
              id="log-grok-pattern-form-submit"
              @onClick="onSubmitForm"
            >
              {{ isEdit ? $t('log.update') : $t('log.create') }}
            </RexButton>
          </div>
        </div>
      </template> -->
    </RexModalV3>
  </div>
</template>

<style lang="scss" scoped>
.footer-container {
  @include flex-center-justify(space-between);
  border-top: 0.063rem solid $border-primary;
  padding-top: 1.5rem;
}
.cancel-btn {
  @include dropshadow-effect($opacity: 0);
  border: none;
  padding: 0;
  margin-right: 1.75rem;
  font-size: 1rem;
}
.submit-btn {
  font-size: 1rem;
  padding: 0 1rem 0 1rem;
}
.grok-input-fields {
  width: 100%;
  margin-bottom: 1.75rem;
}
.grok-input-text-field {
  width: 100%;
  height: 7.5rem;
}
.grok-service-label {
  @include flex-center-justify(space-between);
}
.grok-service-info {
  @include flex-center-justify(space-between);
  color: $font-tertiary;
}
.grouped {
  background-color: $good !important;
}
.non-grouped {
  background-color: $color-brand-accent !important;
}
.grok-service-info-icon {
  height: 1rem;
  width: 1rem;
  background-color: #bbb;
  border-radius: 50%;
  display: inline-block;
  margin-right: 0.5rem;
  margin-left: 0.4rem;
}
:deep(.item-text) {
  word-break: break-all;
  text-overflow: initial;
  white-space: normal;
}
</style>
